import { useEffect, useState } from "react";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { istNow, ymd, useIstDay } from "../lib/dates";

export const PRESETS = [["today", "Today"], ["yesterday", "Yesterday"], ["week", "This Week"], ["month", "This Month"], ["custom", "Custom"]];

// All ranges are computed from the current Asia/Kolkata date.
export const presetRange = (key) => {
  const n = istNow();
  if (key === "yesterday") { const y = new Date(n); y.setDate(n.getDate() - 1); return [ymd(y), ymd(y)]; }
  if (key === "week") { const day = n.getDay(); const diff = day === 0 ? 6 : day - 1; const m = new Date(n); m.setDate(n.getDate() - diff); return [ymd(m), ymd(n)]; }
  if (key === "month") return [ymd(new Date(n.getFullYear(), n.getMonth(), 1)), ymd(n)];
  return [ymd(n), ymd(n)];
};

export const prettyDate = (s) => { if (!s) return ""; const [y, m, d] = s.split("-"); return new Date(y, m - 1, d).toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" }); };

// Shared range state: presets roll over automatically at IST midnight; custom holds From/To until Generate.
export function useReportRange(initial = "today") {
  const [mode, setMode] = useState(initial);
  const [range, setRange] = useState(presetRange(initial));
  const [cs, setCs] = useState(presetRange("month")[0]);
  const [ce, setCe] = useState(presetRange("today")[1]);
  const istDay = useIstDay();
  useEffect(() => { if (mode !== "custom") setRange(presetRange(mode)); }, [mode, istDay]);
  const pick = (k) => { setMode(k); if (k !== "custom") setRange(presetRange(k)); };
  const generate = () => { if (cs && ce && cs <= ce) setRange([cs, ce]); };
  return { mode, pick, start: range[0], end: range[1], cs, ce, setCs, setCe, generate };
}

export function ReportDateFilter({ r, prefix = "filter", className = "" }) {
  return (
    <div className={`flex flex-wrap items-end gap-3 ${className}`} data-testid={`${prefix}-date-filter`}>
      <div className="flex flex-wrap gap-2">
        {PRESETS.map(([k, lbl]) => (
          <Button key={k} data-testid={`${prefix}-${k}`} onClick={() => r.pick(k)} variant={r.mode === k ? "default" : "outline"} className="rounded-sm">{lbl}</Button>
        ))}
      </div>
      {r.mode === "custom" && (
        <div className="flex items-end gap-2">
          <div><span className="text-xs text-muted-foreground block mb-1">From</span><Input type="date" value={r.cs} max={r.ce} onChange={(e) => r.setCs(e.target.value)} data-testid={`${prefix}-custom-start`} className="bg-secondary w-40" /></div>
          <div><span className="text-xs text-muted-foreground block mb-1">To</span><Input type="date" value={r.ce} min={r.cs} onChange={(e) => r.setCe(e.target.value)} data-testid={`${prefix}-custom-end`} className="bg-secondary w-40" /></div>
          <Button data-testid={`${prefix}-generate`} onClick={r.generate} className="rounded-sm">Generate</Button>
        </div>
      )}
      <div className="ml-auto text-sm text-primary" data-testid={`${prefix}-range-label`}>{prettyDate(r.start)} — {prettyDate(r.end)}</div>
    </div>
  );
}
